import { useNavigate } from "react-router-dom"
import React, { useState, useRef, useEffect } from "react"
import styled from "@emotion/styled"
import { Below } from "../UI/Helpers"

const SearchWrapper = styled("li")`
    position: absolute;
    top: 100%;
    right: 0;
    width: 100%;
    background: ${props => props.theme.colors.primary};
    list-style: none;
    input {
        padding: 1.5rem;
        font-size: 1.5rem;
        width: 100%;
        border: none;
        &,
        &:focus,
        &:active {
            outline: none;
        }
    }
    ${props => props.theme.bp.below.lg} {
        top: auto;
        bottom: 0;
        input {
            background: ${props => props.theme.colors.primaryDark};
            color: #fff;
            &::placeholder {
                color: white;
                opacity: 0.5;
            }
        }
    }
`

const SearchButton = styled("i")`
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 1.5rem;
    font-size: 1.5rem;
    color: white;
`

const Search = ({ toggleSearch, toggleMenu }) => {
    const [searchTerm, setSearchTerm] = useState("")
    const [placeholder, setPlaceholder] = useState("Här kan du söka...")
    const navigate = useNavigate()
    const inputRef = useRef(null)

    useEffect(() => {
        inputRef.current?.focus()
    }, [])

    const handleSearch = () => {
        if (searchTerm.trim() !== "") {
            toggleSearch()
            toggleMenu()
            navigate(`/sokresultat/${searchTerm.trim()}`)
        } else {
            setPlaceholder("Du måste skriva något...")
        }
    }

    const onKeyPressed = e => {
        const key = e.keyCode
        if (key === 13) {
            handleSearch()
        }
    }

    const onClick = e => {
        handleSearch()
    }

    const updateSearch = e => {
        setSearchTerm(e.target.value)
        if (placeholder !== "Här kan du söka...") {
            setPlaceholder("Här kan du söka...")
        }
    }

    return (
        <SearchWrapper>
            <input
                ref={inputRef}
                value={searchTerm}
                onChange={updateSearch}
                onKeyDown={onKeyPressed}
                placeholder={placeholder}
            />
            <Below size="lg">
                <SearchButton
                    onClick={onClick}
                    className="fas fa-search"
                />
            </Below>
        </SearchWrapper>
    )
}

export default Search
